import cx from 'classnames';
import { useState } from 'react';
import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import { useGuestVipTier } from 'restaurantAdmin/hooks/useGuestVipTier';
import { GuestVipTierEditForm } from './GuestVipTierEditForm/GuestVipTierEditForm';
import styles from './GuestVipTier.scss';

export interface GuestVipTierProps {
  guestId: string;
  className?: string;
}

export const GuestVipTier = ({ guestId, className }: GuestVipTierProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const { data: guestVipTier, isPending, isError } = useGuestVipTier(guestId);

  if (isPending) {
    return (
      <section className={cx(styles.container, className)}>
        <h3 className={cx(typography.h7, styles.heading)}>VIP Tier</h3>
        <p>Loading...</p>
      </section>
    );
  }

  if (isError || !guestVipTier) {
    return (
      <section className={cx(styles.container, className)}>
        <h3 className={cx(typography.h7, styles.heading)}>VIP Tier</h3>
        <p>Failed to load VIP tier</p>
      </section>
    );
  }

  if (isEditing) {
    return (
      <section className={cx(styles.containerEdit, className)}>
        <h3 className={cx(typography.h7, styles.heading)}>VIP Tier</h3>
        <GuestVipTierEditForm
          guestId={guestId}
          guestVipTier={guestVipTier}
          onComplete={() => setIsEditing(false)}
        />
      </section>
    );
  }

  const { vipTier, isManuallyApplied } = guestVipTier;

  return (
    <section
      className={cx(styles.container, className)}
      aria-labelledby="guest-vip-tier-section"
    >
      <header>
        <h3
          className={cx(typography.h7, styles.heading)}
          id="guest-vip-tier-section"
        >
          VIP Tier
        </h3>
        <button onClick={() => setIsEditing(true)} type="button">
          <Icon name="pencil" />
          <span className={typography.t3}>Edit</span>
        </button>
      </header>

      {vipTier ? (
        <>
          <span className={styles.tierPill}>{vipTier.name}</span>
          <span className={styles.assignmentBadge}>
            {isManuallyApplied ? 'Set manually' : 'Assigned automatically'}
          </span>
        </>
      ) : (
        <span className={styles.noneLabel}>None</span>
      )}
    </section>
  );
};
